'use client';
import { QueryBoundary } from '@shared/api-utils';
import { useInbox } from '@shared/providers';

type InboxMessageLoaderProps = {
  children: React.ReactNode;
  loadingFallback: React.ReactNode;
  errorFallback: React.ReactNode;
};

/**
 * Client side loader component that wraps the inbox query in a QueryBoundary.
 * @param children - the children to render
 * @param loadingFallback - the fallback to render when the query is loading
 * @param errorFallback - the fallback to render when the query errors
 * @returns the QueryBoundary
 */
function InboxMessageLoader({ children, ...props }: InboxMessageLoaderProps) {
  const { query } = useInbox();

  return (
    <QueryBoundary query={query} {...props}>
      {children}
    </QueryBoundary>
  );
}

export { InboxMessageLoader };
